import React from "react";
import styles from "./TableHead.module.scss";

export interface ITableHeadProps {
  className?: string;
  columns?: string[];
}

export const TableHead: React.FC<ITableHeadProps> = ({
  className,
  columns,
}) => {
  return (
    <thead className={`${styles.tableHead} ${className}`}>
      <tr>
        {columns.map((column, index) => (
          <td key={index}>{column}</td>
        ))}
      </tr>
    </thead>
  );
};
